import React from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import { QueryResponse as Risk } from 'api/queries/getRisk.query';

import { TextInput } from 'components/DesignSystem/TextInput/TextInput';
import { distributionOptions } from 'components/widgets/RiskRegister/RiskRegister.utils';
import classes from 'components/widgets/RiskRegister/components/RiskRegisterRoutes/components/Details/Details.module.scss';

export const Likely = () => {
    const { setValue, control, watch } = useFormContext<Risk>();

    const distributionValue = watch('distribution');
    const distributionLabel = distributionOptions.find((option) => option.value === distributionValue)?.label;
    const requiredText = `Middle value is required for ${distributionLabel} distribution`;

    return distributionValue !== 'UNIFORM' ? (
        <div>
            <div className={classes.title}>Likely ({watch('impactType') === 'RELATIVE' ? '%' : 'days'})</div>
            <Controller
                render={({ field }) => (
                    <TextInput
                        {...field}
                        placeholder={'Enter middle value'}
                        className={classes.durationInput}
                        value={field.value?.toString() || ''}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (value === '' || value === '-') {
                                field.onChange(value === '' ? null : value);
                            } else {
                                const numValue = Number(value);
                                if (!isNaN(numValue)) {
                                    field.onChange(numValue);
                                }
                            }
                        }}
                        onClear={() => setValue('distributionRange.middle', null)}
                    />
                )}
                name={'distributionRange.middle'}
                control={control}
                rules={{
                    required: requiredText,
                    validate: {
                        withinRange: (value) => {
                            if (value === null) return true; // Allow null for non-triangle distributions
                            const minValue = watch('distributionRange.min');
                            const maxValue = watch('distributionRange.max');
                            return (
                                (value >= minValue && value <= maxValue) || 'Middle value must be between min and max'
                            );
                        },
                        allowNegativeOnlyForAbsolute: (value) => {
                            if (value === null) return true; // Allow null for non-triangle distributions
                            const impactType = watch('impactType');
                            if (impactType === 'RELATIVE' && value < 0) {
                                return 'Negative values are only allowed for Absolute impact type';
                            }
                            return true;
                        },
                    },
                }}
            />
        </div>
    ) : null;
};
